<template>
  <q-dialog v-model="modalShow" persistent>
    <q-card style="width: 700px">
      <q-card-section class="row items-center">
        <q-avatar icon="far fa-user-shield" color="primary" text-color="white" />
        <span class="q-ml-sm">
          <slot name="content">
            {{ text }}
          </slot>
        </span>
      </q-card-section>

      <q-card-actions align="right">
        <slot name="actions" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'Your changes will not be saved. Do you want to save report ?'
    },
    value: Boolean
  },
  computed: {
    modalShow: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style scoped></style>
